/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_SizeInputs */

const en_admin_resource_form_size = /** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const de_admin_resource_form_size = /** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

const es_admin_resource_form_size = /** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño`)
};

const fr_admin_resource_form_size = /** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superficie`)
};

/** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */
const it_admin_resource_form_size = en_admin_resource_form_size;

/** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */
const pt_br2_admin_resource_form_size = en_admin_resource_form_size;

/** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */
const pl_admin_resource_form_size = en_admin_resource_form_size;

/** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */
const hu_admin_resource_form_size = en_admin_resource_form_size;

/** @type {(inputs: Admin_Resource_Form_SizeInputs) => LocalizedString} */
const ro_admin_resource_form_size = en_admin_resource_form_size;

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Admin_Resource_Form_SizeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_size = /** @type {((inputs?: Admin_Resource_Form_SizeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_SizeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_size(inputs)
	if (locale === "de") return de_admin_resource_form_size(inputs)
	if (locale === "es") return es_admin_resource_form_size(inputs)
	if (locale === "fr") return fr_admin_resource_form_size(inputs)
	if (locale === "it") return it_admin_resource_form_size(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_size(inputs)
	if (locale === "pl") return pl_admin_resource_form_size(inputs)
	if (locale === "hu") return hu_admin_resource_form_size(inputs)
	return ro_admin_resource_form_size(inputs)
});
export { admin_resource_form_size as "admin.resource_form.size" }